import React from 'react';
import TagSystem from '../../components/TagSystem';
import copies from '../../copies.json';
import tagsExample from './tagsExample.svg';

import styles from './TagsPage.module.scss';

const TagsPage = () => {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>{copies.tags?.title}</h1>
            <div className={styles.tagsContainer}>
                <div className={styles.exampleBlock}>
                    <div className={styles.headerTitle}>{copies.tags?.exampleTitle}</div>
                    <div className='flex space-between'>
                        <div className={styles.exampleText} dangerouslySetInnerHTML={{ __html: copies.tags?.description }} />
                        <img className={styles.img} src={tagsExample} alt='tags-example' />
                    </div>
                </div>
                <div className={styles.createSection}>
                    <TagSystem />
                </div>
            </div>
        </div>
    );
};

export default TagsPage;
